/**
 * Endpoints — Veille Qualiopi (hub, fiches, envois, programmations).
 */

export const veilleEndpoints = {
  list: (type) => `/api/veille${type ? `?type=${encodeURIComponent(type)}` : ''}`,
  summary: () => '/api/veille/summary',
  diffusionConfig: () => '/api/veille/config',
  setDiffusionConfig: (type) => `/api/veille/config/${encodeURIComponent(type)}`,
  ressources: (type) => `/api/veille/ressources?type=${encodeURIComponent(type)}`,
  ressourceCounts: () => '/api/veille/ressources/counts',
  createRessource: () => '/api/veille/ressources',
  ressource: (id) => `/api/veille/ressources/${id}`,
  ressourceFichiers: (id) => `/api/veille/ressources/${id}/fichiers`,
  ressourceFichier: (fichierId) => `/api/veille/ressources/fichiers/${fichierId}`,
  ressourceFichierPdf: (fichierId) => `/api/veille/ressources/fichiers/${fichierId}/pdf`,
  pendingCount: () => '/api/veille/pending-count',
  competenceCategories: () => '/api/veille/competence-categories',
  availableImages: () => '/api/veille/available-images',
  generateFromUrl: () => '/api/veille/generate-from-url',
  create: () => '/api/veille/new',
  full: (slug) => `/api/veille/${slug}/full`,
  pdf: (slug) => `/api/veille/${slug}/pdf`,
  update: (slug) => `/api/veille/${slug}`,
  setStatus: (slug) => `/api/veille/${slug}/status`,
  uploadImage: (slug) => `/api/veille/${slug}/image`,
  uploadPdf: (slug) => `/api/veille/${slug}/pdf`,
  recipients: (slug, categoriesCsv) => `/api/veille/${slug}/recipients?categories=${encodeURIComponent(categoriesCsv)}`,
  diffusionLog: (slug) => `/api/veille/${slug}/diffusion-log`,
  setDiffusion: (slug) => `/api/veille/${slug}/diffusion`,
  send: (slug) => `/api/veille/${slug}/send`,
  scheduled: (slug) => `/api/veille/${slug}/scheduled`,
  cancelScheduled: (slug, id) => `/api/veille/${slug}/scheduled/${id}`,
}
